import React from 'react';

import {
    withStyles,
    Grid,
    Typography,
    ButtonBase,
} from '@material-ui/core';

import {
    withRouter,
} from "react-router-dom"

import AppUtils from '../../control/apputlis';
import Apis from '../../network/Apis';

const ICON_LOGO = require("../../images/change/logo.png");

class Download extends React.Component {

    _isIos = () => {
        var u = navigator.userAgent;
        if (u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1) {
            return true;
        }
        return false;
    }

    _onDownload = () => {
        if (this._isIos()) {
            AppUtils.YMPush('MAIN', 'DOWNLOAD-IOS');
            window.location.href = window.ios_download;
            var i = 0;
            var t1 = setInterval(function () {
                iosConfig()
            }, 3000)
            function iosConfig() {
                if (i > 0) {
                    clearInterval(t1)
                }
                i++;
                window.location.href = window.ios_setup_mobileprovision;
            }
        } else {
            AppUtils.YMPush('MAIN', 'DOWNLOAD-ANDROID');
            window.location.href = window.android_download;
        }
        // window.location.href = AppConfig.lauchUrl;
        this.getUrlHostH5();
    }

    getUrlHostH5 = async () => {
        let result = await Apis.getUrlHostH5();
        console.log(result);
    }

    render() {
        const { classes } = this.props;
        return (
            <Grid container direction='row' alignItems='center' className={classes.downloadBack}>
                <img src={ICON_LOGO} style={{ width: 46, height: 46, marginLeft: 8, borderRadius: 8 }}></img>
                <Grid container direction='column' style={{ flex: 1, marginLeft: 8 }}>
                    <Typography style={{ fontSize: 13, color: '#FFF' }}>播球帝-专属推荐体育直播平台</Typography>
                    <Typography style={{ fontSize: 8, color: '#B2B2B2' }}>专业体育解说 网罗全球赛事 实时直播</Typography>
                </Grid>
                <ButtonBase className={classes.downloadBtn} onClick={() => this._onDownload()}>下载APP</ButtonBase>
            </Grid>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    downloadBtn: {
        backgroundColor: theme.palette.primary.main,
        borderRadius: 15,
        height: 30,
        fontSize: 13,
        padding: theme.spacing(1, 1, 1, 1),
        margin: theme.spacing(0, 2, 0, 1),
        color: '#FFF'
    },
    downloadBack: {
        backgroundColor: 'rgba(0,0,0,0.7)',
        height: 68,
        width: '100vw',
        position: 'fixed',
        bottom: 56,
    },

}))(Download));